export function sortPortCallActivities<
	T extends { event: string }
>(
	portCallActivities: T[],
	sortedPortActivities: { name: string }[] // this must be sorted correctly already
): T[] {
	const orderMap = new Map<string, number>();

	if (!Array.isArray(portCallActivities)) {
		return [];
	}

	sortedPortActivities.forEach((activity, index) => {
		orderMap.set(activity.name, index);
	});

	return [...portCallActivities].sort((a, b) => {
		const orderA = orderMap.get(a.event);
		const orderB = orderMap.get(b.event);

		// Unknown events go last
		if (orderA === undefined && orderB === undefined) {
			return 0;
		}

		if (orderA === undefined) {
			return 1;
		}

		if (orderB === undefined) {
			return -1;
		}

		return orderA - orderB;
	});
}
